import { API } from '../Api';

// File âm thanh/gif riêng của creator CAB+ cho hiệu ứng donate.
// Tải lên qua media-service (kiểm file + lưu), xem/xoá qua payment-service.

export interface AlertAsset {
  id: string;
  kind: 'audio' | 'gif';
  url: string;
  sizeBytes: number;
  durationMs: number | null;
  originalName: string | null;
  createdAt: string;
}

export interface MyAlertAssets {
  isPremium: boolean;
  maxAssets: number;
  assets: AlertAsset[];
}

export const getMyAlertAssets = () =>
  API.get<MyAlertAssets>('/v1/payment-service/donate-alert-assets/me').then((r) => r.data);

export const deleteAlertAsset = (id: string) =>
  API.delete<{ deleted: boolean }>(`/v1/payment-service/donate-alert-assets/${id}`).then((r) => r.data);

export const uploadAlertAsset = (file: File) => {
  const form = new FormData();
  form.append('file', file);
  return API.post<AlertAsset>('/v1/media-service/alertassets/upload', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }).then((r) => r.data);
};
